'use client';

import classNames from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Image, { StaticImageData } from 'next/image';

import { PropsWithClassname } from '@/app/types';
import { formatPrice } from '@/app/utils/formatting';

import Button, { ButtonHTMLTag, ButtonStyle } from '@/app/components/Button/Button';

interface RegularDonorWidgetProps extends PropsWithClassname {
  isAmountFilledIn: boolean;
  image: StaticImageData | null;
  amount?: number;
  categoryLabel?: string;
  onEditButtonClick: () => void;
}

const RegularDonorWidget: FC<RegularDonorWidgetProps> = ({
  amount,
  categoryLabel,
  image,
  isAmountFilledIn,
  onEditButtonClick,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(className, 'bg-secondary-light py-[24px] px-[32px] relative rounded-md')}>
      <Button
        tagSpecificProps={{ htmlTag: ButtonHTMLTag.BUTTON, onClick: onEditButtonClick }}
        style={ButtonStyle.PRIMARY_OUTLINED}
        className="absolute top-[8px] right-[8px] bg-white tracking-[2px]"
      >
        {t('components.DonationForm.regularDonorWidgetEditButton')}
      </Button>
      {!!image && (
        <Image src={image} alt={categoryLabel ?? ''} className="h-[88px] max-w-[100%] w-auto mx-auto mb-[16px]" />
      )}
      <p className="font-bold text-center text-[16px] mb-[4px]">
        {t(
          typeof amount !== 'undefined' && isAmountFilledIn
            ? 'components.DonationForm.regularDonorWidgetHeadingWithAmount'
            : 'components.DonationForm.regularDonorWidgetHeadingWithoutAmount',
          {
            amount: amount ? formatPrice(amount) : '',
            category: categoryLabel,
          },
        )}
      </p>
      <p className="text-neutral-mid text-center text-[14px]">{t('components.DonationForm.regularDonorWidgetNote')}</p>
    </div>
  );
};

export default RegularDonorWidget;
